import React, { useState } from "react";
import HibuButton from "./HibuButton";

function Dropdown({ merchant }) {
  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);

    if (value) window.open(value, "width=600,height=700");
  };

  const { family } = merchant;

  return (
    <div>
      <select id="dropdown-link" value={selectedValue} onChange={handleChange}>
        <option value="">Write a Review</option>
        {family.map((option) => (
          <option key={option.id} value={option.surveyUrl}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function AggregateBottomButton({ merchant, writeDisable, truncateDest }) {
  if (merchant.numReviews === 0 && merchant.state === "cancelled") {
    return null;
  } else if (merchant.numReviews <= 4 && merchant.family && !writeDisable) {
    return <Dropdown merchant={merchant} />;
  } else if (merchant.numReviews <= 4 && merchant.state != "cancelled" && !writeDisable) {
    return <HibuButton url={merchant.surveyUrl} text="Write a Review" popUp={true} />;
  } else {
    return <HibuButton url={truncateDest} text="Read More Reviews" />;
  }
}



// WEBPACK FOOTER //
// ./src/components/AggregateBottomButton.js